import ReactMarkdown from 'react-markdown';

const ExperienceCard = ({ experience, index }) => {
    return (
        <article className="group rounded-lg border border-slate-200 bg-white p-6 shadow-sm transition duration-300 hover:-translate-y-1 hover:border-blue-200 hover:shadow-xl dark:border-slate-700 dark:bg-slate-800 dark:hover:border-blue-900 sm:p-8">
            <h2 className="mb-2 text-2xl font-bold leading-tight text-slate-950 dark:text-white sm:text-3xl">
                {experience.workTitle}
            </h2>
            <div className="mb-6 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm sm:text-base">
                <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href={experience.company.link}
                    className="font-semibold text-blue-700 transition-colors hover:text-blue-900 hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-blue-600 dark:text-blue-300 dark:hover:text-blue-200 dark:focus-visible:outline-blue-300"
                >
                    {experience.company.name}
                </a>
                <span aria-hidden="true" className="text-slate-400 dark:text-slate-500">|</span>
                <span className="text-slate-600 dark:text-slate-400">{experience.timeline}</span>
            </div>

            {experience.description && (
                <ul className="space-y-3 border-t border-slate-200 pt-5 text-slate-700 dark:border-slate-700 dark:text-slate-300">
                    {experience.description.map((item, index) => (
                        <li key={index} className="flex items-start">
                            <span className="inline-block w-2 h-2 bg-blue-600 dark:bg-blue-400 rounded-full mt-2 mr-3 flex-shrink-0" />
                            <span className="text-sm sm:text-base leading-relaxed">
                                <ReactMarkdown components={{
                                    p: ({ node, ...props }) => <span {...props} />,
                                    strong: ({ node, ...props }) => <strong className="font-bold" {...props} />,
                                    em: ({ node, ...props }) => <em className="italic" {...props} />,
                                }}>
                                    {item}
                                </ReactMarkdown>
                            </span>
                        </li>
                    ))}
                </ul>
            )}
        </article>
    );
};

export default ExperienceCard;